import { SystemStyleObject } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'

export type { ColorScheme }

export type ChipVariant = 'field' | 'category'

// field: inverted chip-in-field surface — always light bg / dark text
// category: brand accent (signal yellow) — same in both modes
const tokens: Record<ChipVariant, { bg: string; color: string }> = {
  field: {
    bg: 'bg.chip-in-field',
    color: 'text.chip-in-field',
  },
  category: {
    // Signal yellow and its dark label are brand accents — same in both modes
    bg: 'bg.chip',
    color: 'text.chip-label',
  },
}

const lightTokens: Record<ChipVariant, { bg: string; color: string }> = {
  field: {
    bg: 'light.bg.chip-in-field',
    color: 'light.text.chip-in-field',
  },
  category: {
    bg: 'light.bg.chip',
    color: 'light.text.chip-label',
  },
}

export const chipStyles = (
  variant: ChipVariant = 'field',
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => {
  const t = colorScheme === 'dark' ? tokens[variant] : lightTokens[variant]
  return {
    display: 'inline-flex',
    alignItems: 'center',
    bg: t.bg,
    color: t.color,
    borderRadius: '4px',
    px: variant === 'category' ? '10px' : '8px',
    py: variant === 'category' ? '4px' : '2px',
    fontFamily: "'Soehne Kraftig', sans-serif",
    fontSize: variant === 'category' ? '12px' : '14px',
    fontWeight: '500',
    lineHeight: variant === 'category' ? '16px' : '20px',
    whiteSpace: 'nowrap',
    userSelect: 'none',
  }
}

export const dismissButtonStyles = (
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'none',
  border: 'none',
  padding: '0',
  marginLeft: '4px',
  cursor: 'pointer',
  color: 'inherit',
  lineHeight: '0',
  flexShrink: 0,
  borderRadius: '2px',
  _hover: {
    opacity: 0.7,
  },
  _focusVisible: {
    outline: '2px solid',
    outlineColor:
      colorScheme === 'light'
        ? 'light.interactive.focus-ring'
        : 'interactive.focus-ring',
    outlineOffset: '1px',
  },
})
